import { Badge } from '../components/ui';

// Constants for group statuses
export const SUBSCRIPTION_STATUS = {
  SUBSCRIBED: 'subscribed',
  PENDING: 'pending',
  FAILED: 'failed'
};

export const BASIC_INFO_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  INACCESSIBLE: 'inaccessible'
};

export const AI_ANALYSIS_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed'
};

export const QUALITY_CHECK_STATUS = {
  PENDING: 'pending',
  PASSED: 'passed',
  FAILED: 'failed'
};

export const CHAT_TYPES = {
  SUPERGROUP: 'chatTypeSupergroup',
  BASIC_GROUP: 'chatTypeBasicGroup',
  CHANNEL: 'chatTypeChannel',
  PRIVATE: 'chatTypePrivate',
  SECRET: 'chatTypeSecret'
};

export const DISCOVERY_SOURCES = {
  MANUAL: 'manual',
  ACCOUNT_DISCOVERY: 'account_discovery'
};

// Helper functions
export const getGroupType = (type) => {
  switch (type) {
    case CHAT_TYPES.SUPERGROUP:
      return 'Супергруппа';
    case CHAT_TYPES.BASIC_GROUP:
      return 'Группа';
    case CHAT_TYPES.CHANNEL:
      return 'Канал';
    case CHAT_TYPES.PRIVATE:
      return 'Личный чат';
    case CHAT_TYPES.SECRET:
      return 'Секретный чат';
    default:
      return type || 'Неизвестно';
  }
};

export const getPrivacyStatus = (chat_username) => {
  return chat_username ? 'Публичная' : 'Приватная';
};

// Badge components
export const getSubscriptionBadge = (status) => {
  switch (status) {
    case SUBSCRIPTION_STATUS.SUBSCRIBED:
      return <Badge variant="green">✓ Subscribed</Badge>;
    case SUBSCRIPTION_STATUS.PENDING:
      return <Badge variant="yellow">⏳ Pending</Badge>;
    case SUBSCRIPTION_STATUS.FAILED:
      return <Badge variant="red">❌ Failed</Badge>;
    default:
      return <Badge variant="gray">? Unknown</Badge>;
  }
};

export const getBasicInfoBadge = (status) => {
  switch (status) {
    case BASIC_INFO_STATUS.COMPLETED:
      return <Badge variant="green">✓ Completed</Badge>;
    case BASIC_INFO_STATUS.PENDING:
      return <Badge variant="yellow">⏳ Pending</Badge>;
    case BASIC_INFO_STATUS.FAILED:
      return <Badge variant="red">❌ Failed</Badge>;
    case BASIC_INFO_STATUS.INACCESSIBLE:
      return <Badge variant="red">🚫 Inaccessible</Badge>;
    case null:
    case undefined:
    case '':
      return <Badge variant="gray">⏳ Pending</Badge>;
    default:
      return <Badge variant="gray">? Unknown</Badge>;
  }
};

export const getAnalysisBadge = (status) => {
  switch (status) {
    case AI_ANALYSIS_STATUS.COMPLETED:
      return <Badge variant="green">Analyzed</Badge>;
    case AI_ANALYSIS_STATUS.FAILED:
      return <Badge variant="red">Failed</Badge>;
    case AI_ANALYSIS_STATUS.PENDING:
    default:
      return <Badge variant="gray">Pending</Badge>;
  }
};

export const getQualityBadge = (quality, status) => {
  // Return only the numeric quality score
  if (quality !== null && quality !== undefined) {
    return <span className="text-sm font-mono">{quality}</span>;
  } else {
    return <span className="text-sm text-gray-400">-</span>;
  }
};

export const getTypeBadge = (type) => {
  switch (type) {
    case CHAT_TYPES.SUPERGROUP:
      return <Badge variant="blue">Супергруппа</Badge>;
    case CHAT_TYPES.BASIC_GROUP:
      return <Badge variant="purple">Группа</Badge>;
    case CHAT_TYPES.CHANNEL:
      return <Badge variant="indigo">Канал</Badge>;
    case CHAT_TYPES.PRIVATE:
      return <Badge variant="gray">Личный чат</Badge>;
    case CHAT_TYPES.SECRET:
      return <Badge variant="gray">Секретный</Badge>;
    default:
      return <Badge variant="gray">{getGroupType(type)}</Badge>;
  }
};

export const getPrivacyBadge = (chat_username) => {
  return chat_username ? 
    <Badge variant="green">Публичная</Badge> : 
    <Badge variant="yellow">Приватная</Badge>;
};

// Export all badge functions as a single object for easy importing
export const GroupBadges = {
  getSubscriptionBadge,
  getBasicInfoBadge,
  getAnalysisBadge,
  getQualityBadge,
  getTypeBadge,
  getPrivacyBadge
};

// Export status constants as a single object
export const GroupStatus = {
  SUBSCRIPTION_STATUS,
  BASIC_INFO_STATUS,
  AI_ANALYSIS_STATUS,
  QUALITY_CHECK_STATUS,
  CHAT_TYPES,
  DISCOVERY_SOURCES
};
